export default __webpack_public_path__ + "static/media/learose2-480w.6c380f39.avif";